module.exports = __webpack_public_path__ + "static/media/label-unchecked.aaef950c.svg";